export class ApiCourseObjectiveUpdate {
    id: number;
    sort_order: number;
    description: string;

    constructor(data) {
        if (data.id) this.id = data.id;
        this.sort_order = data.sortOrder!= null? data.sortOrder: "";
        this.description = data.description;
    }
}